import { urnToRef } from "banco/util/formatter";

export class SmartlookSupport {
  private static get smartlookEnabled() {
    return typeof window.smartlook !== "undefined"
      && window.static_data.feature_flags.smartlook_events_enabled;
  }

  static identifySession(attrs = {}) {
    if (typeof window.smartlook !== "undefined") {
      window.smartlook("record", { forms: true, numbers: true });

      const current_princ = window.current_principal;
      let principalRef = null;

      // We only want to attach an identifier to the session if it's a customer
      if (current_princ?.urn?.includes("customer")) {
        principalRef = urnToRef(current_princ.urn);
      } else if (attrs && "customer_ref" in attrs) {
        principalRef = attrs.customer_ref as string;
      }

      if (principalRef) {
        window.smartlook("identify", principalRef, { ...attrs, name: principalRef });
      }
    }
  }

  static sendError(message: string, args: { [key: string]: unknown }) {
    if (SmartlookSupport.smartlookEnabled) {
      window.smartlook!("track", "error", { ...args, message });
    }
  }

  static reportSessionEvent(
    eventName: string,
    eventRef?: string,
    attrs?: { [key: string]: unknown }
  ) {
    if (SmartlookSupport.smartlookEnabled) {
      if (eventRef) {
        window.smartlook!("track", eventName, { ref: eventRef });
      } else {
        window.smartlook!("track", eventName);
      }
    }

    if (attrs) {
      SmartlookSupport.identifySession(attrs);
    }
  }

  static reportProofUploadAttempted(proof_type: string) {
    SmartlookSupport.reportSessionEvent(proof_type + "_upload_attempted");
  }
}

window.SmartlookSupport = SmartlookSupport;
